export default __webpack_public_path__ + "static/media/pay_redeem.7ad16a15.svg";